// NotificationContext.tsx
import React, { createContext, useState, ReactNode } from 'react';
import Notification, { NotificationProps } from '../components/Notification';

export type NotificationType = 'success' | 'info' | 'warning' | 'error';

interface NotificationContextType {
  showNotification: (message: string, type: NotificationType) => void;
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

interface NotificationProviderProps {
  children: ReactNode;
}

export const NotificationProvider: React.FC<NotificationProviderProps> = ({ children }) => {
  const [notification, setNotification] = useState<NotificationProps | null>();

  const showNotification = (message: string, type: NotificationType) => {
    setNotification({ open: true, message, severity: type, onClose: handleClose });
  };

  const handleClose = () => {
    setNotification(null);
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      {notification && (
        <Notification
          open={notification.open}
          message={notification.message}
          severity={notification.severity}
          onClose={notification.onClose}
        />
      )}
    </NotificationContext.Provider>
  );
};
